import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Axios from 'axios';
import * as serviceWorker from './serviceWorker';
import { GoogleOAuthProvider } from '@react-oauth/google';

// import ScriptTag from 'react-script-tag';
// const Demo = props => (
// <ScriptTag type="text/javascript" src="https://cdn.onesignal.com/sdks/OneSignalSDK.js" />
// )

  // Set API url
  Axios.defaults.baseURL = 'https://api.yuzer.com.br/api/';
  // Axios.defaults.baseURL = 'http://localhost:8001/api/';
  // Axios.defaults.baseURL = 'https://d5fc-2804-4d98-151-e400-941f-1b6f-e059-a727.ngrok-free.app/api/';
  // Axios.defaults.headers.common['ngrok-skip-browser-warning'] = 'true';

  ReactDOM.render(
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </GoogleOAuthProvider>,
    document.getElementById('root')
  );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
